(() => {
  window.FerretiBA26 = {
    giftPlan(lines) {
      const count = lines.reduce((sum, line) => sum + (line.eligible ? line.quantity : 0), 0);
      const gifts = lines.filter(line => line.managed);
      const updates = {};
      gifts.forEach((line, index) => {
        const wanted = count >= 3 && index === 0 ? 1 : 0;
        if (line.quantity !== wanted) updates[line.key] = wanted;
      });
      return { updates, add: count >= 3 && gifts.length === 0 };
    },
    selectionTotal(prices) {
      const sorted = [...prices].sort((a, b) => a - b);
      const sum = sorted.reduce((total, price) => total + price, 0);
      if (sorted.length === 2) return Math.round(sum * 0.85);
      return sum - sorted.slice(0, Math.floor(sorted.length / 3)).reduce((total, price) => total + price, 0);
    },
  };
})();
